module.exports = __webpack_public_path__ + "static/media/eli-lilly.aea44f09.png";